import React from 'react';
import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';
import get from 'lodash/get';
import find from 'lodash/find';
import includes from 'lodash/includes';

import { COUNTRY_SELECTION } from '../../utils';
import styles from './AddressOption.module.css';

const formatAddress = (value) => startCase(toLower(value));

const AddressOption = ({
  title,
  data,
  suggestedFields,
  isSelected,
  onClick,
}) => {
  const { primaryLine, secondaryLine, city, state, zip, countryCode } = data;
  const icon = isSelected ? 'fas fa-check-square' : 'far fa-square';
  const suggestedField = (field) => includes(suggestedFields, field);

  return (
    <button
      type="button"
      className={`${styles.container} ${isSelected ? styles.selected : ''}`}
      onClick={onClick}
    >
      <i className={icon} />
      <div className={styles.address}>
        <p className={styles.title}>{`${title}:`}</p>
        <p
          className={`${suggestedField('primaryLine') ? styles.suggested : ''}`}
        >
          {formatAddress(primaryLine)}
        </p>
        {secondaryLine && (
          <p
            className={`${
              suggestedField('secondaryLine') ? styles.suggested : ''
            }`}
          >
            {formatAddress(secondaryLine)}
          </p>
        )}
        <p>
          <span className={`${suggestedField('city') ? styles.suggested : ''}`}>
            {formatAddress(city)}
          </span>
          <span>, </span>
          {state && (
            <span
              className={`${suggestedField('state') ? styles.suggested : ''}`}
            >
              {`${state} `}
            </span>
          )}
          <span className={`${suggestedField('zip') ? styles.suggested : ''}`}>
            {zip}
          </span>
        </p>
        <p>{get(find(COUNTRY_SELECTION, ['code', countryCode]), 'name')}</p>
      </div>
    </button>
  );
};

AddressOption.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape().isRequired,
  suggestedFields: PropTypes.arrayOf(PropTypes.string),
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

AddressOption.defaultProps = {
  suggestedFields: [],
};

export default AddressOption;
